import { HTMLAttributes } from 'react';

/**
 * MUI types the select's display element as plain div props, which excludes
 * `data-*`. The attribute is what the e2e suite selects a list by, so it goes
 * on with a narrow cast rather than a looser prop type.
 */
export const selectTestId = (id: string): HTMLAttributes<HTMLDivElement> =>
  ({ 'data-testid': id } as HTMLAttributes<HTMLDivElement>);
